import React from 'react';
import classNames from 'classnames';
import { COLORS_WITH_OPACITY } from '../colors';
const Divider = ({ className, color, isVertical }) => {
    const classNameResult = classNames('divider', isVertical ? 'vertical ' : '', className);
    return React.createElement("hr", { style: { borderColor: color ? color : COLORS_WITH_OPACITY.lightSapphire }, className: classNameResult });
};
export { Divider };
//# sourceMappingURL=Divider.js.map